import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import {
  IInquiryFeeTypeSetting,
  IInquiryFeeTypeSettingFilter,
  ICreateUpdateInquiryFeeTypeSetting,
} from "@models/receiptType/receiptTypeModel"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "../httpService"

class InquiryFeeTypeSettingService {
  /**
   * Lấy danh sách có phân trang (yêu cầu permission Read)
   */
  public async getAll(
    params: IInquiryFeeTypeSettingFilter
  ): Promise<PagedResultDto<IInquiryFeeTypeSetting>> {
    const res = await http.get(
      "api/services/app/InquiryFeeTypeSetting/GetAll",
      { params }
    )
    return res.data.result
  }

  /**
   * Lấy danh sách active theo objectType — dùng cho dropdown, không cần permission
   */
  public async getList(objectType?: number): Promise<IInquiryFeeTypeSetting[]> {
    const res = await http.get(
      "api/services/app/InquiryFeeTypeSetting/GetList",
      { params: { objectType } }
    )
    return res.data.result ?? []
  }

  /**
   * Lấy chi tiết 1 bản ghi (yêu cầu permission Read)
   */
  public async get(id: number): Promise<IInquiryFeeTypeSetting> {
    const res = await http.get(
      "api/services/app/InquiryFeeTypeSetting/Get",
      { params: { id } }
    )
    return res.data.result
  }

  /**
   * Tạo mới hoặc cập nhật (permission Create / Update)
   */
  public async createOrUpdate(
    body: ICreateUpdateInquiryFeeTypeSetting
  ): Promise<IInquiryFeeTypeSetting> {
    const res = await http.post(
      "api/services/app/InquiryFeeTypeSetting/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  /**
   * Xóa bản ghi (permission Delete)
   */
  public async delete(id: number): Promise<void> {
    await http.delete(
      "api/services/app/InquiryFeeTypeSetting/Delete",
      { params: { id } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("DELETED_SUCCESSFULLY")
    )
  }
}

export default new InquiryFeeTypeSettingService()
